var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHexagon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 98,
    viewBox: "0 0 95 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_9432_283888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1613 34.9071L32.0234 43.5669V60.8865L17.1613 69.5463L2.29918 60.8865V43.5669L17.1613 34.9071Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M49.0324 34.9071L63.8945 43.5669V60.8865L49.0324 69.5463L34.1703 60.8865V43.5669L49.0324 34.9071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M64.9679 6.45312L79.83 15.1129V32.4325L64.9679 41.0923L50.1058 32.4325V15.1129L64.9679 6.45312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.839 6.45312L111.701 15.1129V32.4325L96.839 41.0923L81.9769 32.4325V15.1129L96.839 6.45312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9035 34.9072L95.7656 43.567V60.8866L80.9035 69.5464L66.0414 60.8866V43.567L80.9035 34.9072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M33.0968 63.3613L47.9589 72.0211V89.3407L33.0968 98.0005L18.2347 89.3407V72.0211L33.0968 63.3613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M64.9679 63.3613L79.83 72.0211V89.3407L64.9679 98.0005L50.1058 89.3407V72.0211L64.9679 63.3613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.839 63.3613L111.701 72.0211V89.3407L96.839 98.0005L81.9769 89.3407V72.0211L96.839 63.3613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M49.0324 -22L63.8945 -13.3402V3.97937L49.0324 12.6392L34.1703 3.97937V-13.3402L49.0324 -22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.1613 -22L32.0234 -13.3402V3.97937L17.1613 12.6392L2.29918 3.97937V-13.3402L17.1613 -22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9035 -22L95.7656 -13.3402V3.97937L80.9035 12.6392L66.0414 3.97937V-13.3402L80.9035 -22Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9432_283888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHexagon);
export default __webpack_public_path__ + "static/media/ic_hexagon.516aa6a336cf078d431dea029ad538e9.svg";
export { ForwardRef as ReactComponent };